module.exports = __webpack_public_path__ + "media/images/vector-27@2x-3dddc5c0d6212f0f78ed09159e5847a2.png";